import PropTypes from "prop-types";
import React from "react";

import { createComponent } from "@evertrue/et-flux";
import { Loading } from "components/et-factories";
import { Redirect } from "components/router";
import SessionSource from "apps/auth/sources/session-source";
import LidsSource from "apps/auth/sources/lids-source";
import LidsStore from "apps/auth/stores/lids-store";
import ModuleClass from "components/module";

const Module = React.createFactory(ModuleClass);

export default createComponent("LinkedinConnectController", {
  propTypes: {
    params: PropTypes.object,
  },

  registerStores() {
    return this.on(LidsStore, () => ({ is_connected: LidsStore.isConnected() }));
  },

  componentDidMount() {
    SessionSource.setApiSessionFromStorage();
    LidsSource.linkedInCallback(this.props.params);
  },

  render() {
    return Module(
      { className: "linkedin-connect" },
      this.state.is_connected ? Redirect({ to: "/" }) : undefined,

      Loading({
        text: "Please wait while we connect your account...",
        position: "top",
      }),
    );
  },
});
